<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'fas fa-ellipsis-v' : 'fas fa-ellipsis-h'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{this.$route.name}}</a>
        
      </div>
      <div class="navbar-header navbar-messages" v-if="portal_message">
        <i class="fas fa-bell red_blink"></i> {{ portal_message }}
      </div>
      <div class="collapse navbar-collapse ">
        <ul class="nav navbar-nav navbar-right">
          <li><router-link class="borderedButton text" tag="a" :to="{path: 'fileservice', params: {tab: 'upload'}}"><i class="fas fa-upload"></i> {{ $t('upload_now') }}</router-link></li>
          <li class="text"></li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    data () {
      return {
        activeNotifications: false,
        notificationData: '',
        user: {},
        portal_message: ''
      }
    },
    methods: {
      getPortalMessage() {
        this.portal_message = typeof (Webservice.getSetting('portal_message') !== undefined) ? Webservice.getSetting('portal_message') :'';
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    },
    mounted: function () {
      this.getPortalMessage()
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue